import React, { useEffect, useMemo, useState } from 'react';
import './settings.css';

const CYCLE_INTERVAL_MS = 1800;

/**
 * Animated status text shown while an API key is being validated with the
 * vendor. Cycles through a few phrases (fade/slide between them) so the user
 * sees progress instead of a static "Validating…" label.
 */
const ValidatingStatusText = ({ providerDisplayName }) => {
    const phrases = useMemo(
        () => [
            'Validating key…',
            `Contacting ${providerDisplayName || 'the provider'}…`,
            'Checking model access…',
            'Almost done…',
        ],
        [providerDisplayName],
    );
    const [phraseIndex, setPhraseIndex] = useState(0);

    useEffect(() => {
        setPhraseIndex(0);
        const id = setInterval(() => {
            setPhraseIndex((prev) => (prev + 1) % phrases.length);
        }, CYCLE_INTERVAL_MS);
        return () => clearInterval(id);
    }, [phrases]);

    return (
        <span className="settings-validating-status" role="status" aria-live="polite">
            {/* Remounting on index change restarts the enter animation. */}
            <span key={phraseIndex} className="settings-validating-status__phrase">
                {phrases[phraseIndex]}
            </span>
        </span>
    );
};

export default ValidatingStatusText;
